import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Layout from "./pages/Layout";
import Home from "./pages/Home"
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login"
import AdminLayout from "./pages/AdminLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import CategoryAdd from "./pages/dashboard/CategoryAdd";
import { createStore } from "./store/state";
import { setAuthToken } from "./controller/api";
import CategoryList from "./pages/dashboard/CategoryList";
import ProductList from "./pages/dashboard/ProductList";
import ProductAdd from "./pages/dashboard/ProductAdd";
import Cart from "./pages/Cart";
import BookingList from "./pages/dashboard/BookingList";
import CouponList from "./pages/dashboard/CouponList";
import CouponAdd from "./pages/dashboard/CouponAdd";
import ChangePassword from "./pages/dashboard/ChangePassword";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Product from "./pages/Product";
import Orders from "./pages/dashboard/Orders";

function App() {

  useEffect(() => {
  }, [])

  return (
    <div className="app">
      {/* "homepage": "https://www.mrhussain.in/portfolio/doctor-appointment", */}
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      <Router basename="/portfolio/doctor-appointment">
        {/* <Router> */}
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/overview" />} />
            <Route path="overview" element={<Home />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/doctor/:name" element={<Product />} />
          </Route>
          <Route element={<AdminLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/order-list" element={<BookingList />} />
            <Route path="/dashboard/products" element={<ProductList />} />
            <Route path="/dashboard/add-product" element={<ProductAdd />} />
            <Route path="/dashboard/category" element={<CategoryList />} />
            <Route path="/dashboard/category-create" element={<CategoryAdd />} />
            <Route path="/dashboard/coupon" element={<CouponList />} />
            <Route path="/dashboard/coupon-create" element={<CouponAdd />} />
            <Route path="/dashboard/change-password" element={<ChangePassword />} />
            <Route path="/dashboard/orders" element={<Orders />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
